import { Link, useLocation } from 'react-router-dom';
import { useLocalization } from '@fluent/react';

import brandLogoUrl from '#/assets/brand_logo.svg';
import { PublicRoute } from '#/constants/page-route';

const SignUpLayout: React.FC<SignUpLayoutProps> = ({ children }) => {
  return (
    <div className="md:grid md:grid-cols-2">
      <div className="c-accent-1 px-6 py-8 md:px-16 md:py-12">
        <div className="sticky top-12">
          <h1>
            <img src={brandLogoUrl} className="w-full" />
          </h1>

          <div className="mt-24 md:mt-36">
            <h4>You're invited.</h4>
            <p className="text-opacity-70 mt-2">Be the first to use MOVE when we launch.</p>
          </div>
        </div>
      </div>

      <div>
        <main>{children}</main>
        <SignUpLayoutFooter />
      </div>
    </div>
  );
};
export type SignUpLayoutProps = {
  children: React.ReactNode;
};

const SignUpLayoutFooter = () => {
  const { l10n } = useLocalization();
  const location = useLocation();
  const signUpLink =
    location.pathname === PublicRoute.LogisticsSignup
      ? PublicRoute.CustomerSignup
      : PublicRoute.LogisticsSignup;
  const signUpTarget =
    location.pathname === PublicRoute.LogisticsSignup
      ? l10n.getString('client')
      : l10n.getString('transporter');
  const signUpSentence =
    location.pathname === PublicRoute.LogisticsSignup
      ? 'Want to provide your transportation service on MOVE?'
      : 'Want to send your cargo or goods with MOVE?';

  return (
    <footer className="px-6 py-6 space-y-2">
      <div className="max-w-lg mx-auto">
        <p className="text text-neutral-500">{signUpSentence}</p>
        <Link className="inline-block underline" to={signUpLink}>
          Sign up as {signUpTarget} here.
        </Link>
      </div>
    </footer>
  );
};

export default SignUpLayout;
